import React, { ChangeEvent } from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';

const CheckboxContainer = styled.label<Required<Pick<CheckboxProps, 'height'>>>`
  display: flex;
  position: relative;
  height: ${(props) => props.height}px;
  width: fit-content;
  margin-bottom: 0;

  &:hover input ~ span {
    background-color: #ccc;
  }
`;

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ span {
    border: 1px #28b3c1 solid;
  }

  &:checked ~ span:after {
    display: flex;
  }
`;

const Checkmark = styled.span<Required<Pick<CheckboxProps, 'width'>>>`
  position: absolute;
  top: 0;
  left: 0;
  height: inherit;
  width: ${(props) => props.width}px;
  border: 1px #ccc solid;
  border-radius: 5px;

  &:after {
    content: '';
    display: none;
  }

  &:after {
    width: 70%;
    height: 70%;
    background: #28b3c1;
    border-radius: 4px;
    margin: 15%;
  }
`;

const Label = styled.div`
  align-self: center;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: ${colours.greyDarkAlt2};
`;

export type CheckboxProps = {
  checked?: boolean;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement> | undefined) => void;
  width?: number;
  height?: number;
  label?: string;
};

export default function Checkbox({
  name,
  checked,
  height = 25,
  width = 25,
  onChange,
  label,
  ...otherProps
}: CheckboxProps) {
  return (
    <CheckboxContainer height={height} {...otherProps}>
      {label && <Label style={{ marginLeft: width + 15 }}>{label}</Label>}
      <CheckboxInput
        type='checkbox'
        name={name}
        onChange={onChange}
        checked={checked}
      />
      <Checkmark width={width} />
    </CheckboxContainer>
  );
}
